import home from './home'

const messages = {
    home
}

export default messages


// WEBPACK FOOTER //
// ./src/language/en/index.js